import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {apiconfig} from "../app/api.config";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "./AuthService";
import {LogaDay} from "../model/LogaDay";


@Injectable()
export class LogaDayService {

  apiConfig: any = apiconfig;

  constructor(protected http: HttpClient, public authService: AuthService) {
  }

  loadLogaDay(logaDayId: number): Observable<LogaDay> {

    return Observable.create(obs => {

      let h = this.authService.getHttpAuth();

      this.http
        .get(this.apiConfig.API_URL + '/operational/loga-day/' + logaDayId, {headers: h})
        .subscribe(response => {
            if (response) {
              obs.next(LogaDay.fromJson(response));
              obs.complete();
            }
          },
          (error) => {
            // TODO :
          })
      ;

    });

  }
}



// WEBPACK FOOTER //
// ./src/services/LogaDayService.ts